<!--
 * @Author: wsx
 * @Date: 2022-01-14 10:26:06
 * @LastEditTime: 2022-06-13 12:03:18
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description: 街道
-->
<template>
  <el-form :inline="true" :rules="rules" :model="tableParams" class="form-box">
    <el-form-item style="width: 150px">
      <el-button type="primary" @click="handleClick({ emitKey: 'add' })"
        >新增巡防</el-button
      >
    </el-form-item>
    <el-form-item label="巡防名称" prop="patrolmanName">
      <el-input
        v-model="tableParams.patrolmanName"
        placeholder="巡防名称"
        clearable
      ></el-input>
    </el-form-item>

    <el-form-item label="巡防类型" prop="patrolmanType">
      <h-selectcode
        type="zaxf_patrolman_type"
        v-model="tableParams.patrolmanType"
        placeholder=""
      ></h-selectcode>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="refreshTable">查询</el-button>
    </el-form-item>
  </el-form>
  <div class="patrolTable">
    <h-table
      ref="tableRef"
      v-model:columns="columns"
      :method="userList"
      :params="tableParams"
      @handleClick="handleClick"
    >
    </h-table>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watch,
  ref,
  watchEffect,
  nextTick,
} from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { userList, userDetele } from "@/api/system/patrol";

import util from "@util/js";
export default defineComponent({
  name: "patrolTable",
  components: {},
  props: {
    region: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, context) {
    const state = reactive({
      tableParams: {
        patrolmanType: "",
        regionId: "",
        patrolmanColor: "",
        patrolmanName: "",
      },
      moveVisible: false,
      columns: [
        { type: "index" },
        {
          label: "巡防名称",
          prop: "patrolmanName",
        },
        {
          label: "巡防类型",
          prop: "patrolmanTypeDict",
        },
        {
          label: "巡防线颜色",
          prop: "patrolmanColor",
        },
        {
          type: "operate",
          label: "操作",
          width: "190px",
          operates: [
            { name: "编辑巡防", emitKey: "edit" },
            { name: "巡防详情", emitKey: "detils" },
            { name: "删除", emitKey: "del", type: "danger" },
          ],
        },
      ],
      regionVisible: false,
      tableRow: {},
    });
    const tableRef = ref(null);
    const refData = toRefs(state);
    watchEffect(() => {
      //       if (v.type !== "root") {

      // }
      state.tableParams.regionId = props.region.id;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    });
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      if (emitKey === "edit") {
        context.emit("editPatrol", row);
      } else if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该巡防信息吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          async () => {
            const params = {
              ids: [row.patrolmanId],
            };
            const res = await userDetele(params);
            if (res.code === 0) {
              refreshTable();
              ElMessage({
                type: "success",
                message: "删除成功",
              });
            }
          },
          () => {}
        );
      } else if (emitKey === "add") {
        context.emit("addPatrol");
      } else if (emitKey === "detils") {
        context.emit("detils", row);
      }
    };
    return {
      ...refData,
      userList,
      tableRef,
      handleClick,
      refreshTable,
    };
  },
});
</script>
<style lang="scss" scoped>
.patrolTable {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .organTransfer {
    height: 400px;
  }
}
</style>
